'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var ListContext = require('./ListContext.js');
var SortButton = require('./SortButton.js');
var sortTypes = require('./sortTypes.js');

var SortableTableHeaderCell = function (_a) {
    var children = _a.children, buttonClassName = _a.buttonClassName, labelWrapperClassName = _a.labelWrapperClassName, invertArrows = _a.invertArrows, footnote = _a.footnote, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick, _c = _a.role, role = _c === void 0 ? 'columnheader' : _c, sortBy = _a.sortBy, sortType = _a.sortType, props = tslib.__rest(_a, ["children", "buttonClassName", "labelWrapperClassName", "invertArrows", "footnote", "disabled", "onClick", "role", "sortBy", "sortType"]);
    var ctx = react.useContext(ListContext.default);
    var active = ctx.getSortBy() === sortBy;
    var sortDirection = ctx.getSortDirection();
    var listSize = ctx.listSize || 0;
    var ariaSortDirection = sortDirection === 1 ? sortTypes.SortOrderType.ASCENDING : sortTypes.SortOrderType.DESCENDING;
    var ariaSort = active ? ariaSortDirection : sortTypes.SortOrderType.NONE;
    var onButtonClick = function () {
        if (onClick) {
            //Call to custom onClick function received in props in order to handle the sort from server side
            onClick(sortBy, sortDirection, active);
        }
        ctx.setCurrentPage(1);
        ctx.sortList(sortBy, sortType);
    };
    return (jsxRuntime.jsx("th", tslib.__assign({ "aria-sort": ariaSort, role: role }, props, { children: jsxRuntime.jsx(SortButton.default, tslib.__assign({ active: active, buttonClassName: buttonClassName, disabled: disabled, footnote: footnote, onClick: onButtonClick, invertArrows: invertArrows, labelWrapperClassName: labelWrapperClassName, sortDirection: sortDirection, hideSortButtons: listSize === 0 }, { children: children })) })));
};
var SortableTableHeaderCell$1 = SortableTableHeaderCell;

exports.default = SortableTableHeaderCell$1;
//# sourceMappingURL=SortableTableHeaderCell.js.map
